<div class="right-sidebar">
  <div class="tabs-header">
    <div class="tabs-steps" role="list" aria-label="Publish wizard steps">
      <div
        class="tab-step"
        role="listitem"
        [class.active]="isStepActive('dest')"
        [class.completed]="isStepCompleted('dest')"
        [attr.aria-current]="isStepActive('dest') ? 'step' : null"
      >
        <span class="tab-step__circle" aria-hidden="true">
          <svg
            *ngIf="isStepCompleted('dest')"
            class="tab-step__check"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
          <ng-container *ngIf="!isStepCompleted('dest')">1</ng-container>
        </span>
        <span class="tab-step__label">Dest...</span>
      </div>
      <span class="tabs-steps__connector" aria-hidden="true"></span>
      <div
        class="tab-step"
        role="listitem"
        [class.active]="isStepActive('thumbnail')"
        [class.completed]="isStepCompleted('thumbnail')"
        [attr.aria-current]="isStepActive('thumbnail') ? 'step' : null"
      >
        <span class="tab-step__circle" aria-hidden="true">
          <svg
            *ngIf="isStepCompleted('thumbnail')"
            class="tab-step__check"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
          <ng-container *ngIf="!isStepCompleted('thumbnail')">2</ng-container>
        </span>
        <span class="tab-step__label">Thumb...</span>
      </div>
      <span class="tabs-steps__connector" aria-hidden="true"></span>
      <div
        class="tab-step"
        role="listitem"
        [class.active]="isStepActive('metadata')"
        [class.completed]="isStepCompleted('metadata')"
        [attr.aria-current]="isStepActive('metadata') ? 'step' : null"
      >
        <span class="tab-step__circle" aria-hidden="true">
          <svg
            *ngIf="isStepCompleted('metadata')"
            class="tab-step__check"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
          <ng-container *ngIf="!isStepCompleted('metadata')">3</ng-container>
        </span>
        <span class="tab-step__label">Meta...</span>
      </div>
      <span class="tabs-steps__connector" aria-hidden="true"></span>
      <div
        class="tab-step"
        role="listitem"
        [class.active]="isStepActive('publish')"
        [class.completed]="isStepCompleted('publish')"
        [attr.aria-current]="isStepActive('publish') ? 'step' : null"
      >
        <span class="tab-step__circle" aria-hidden="true">
          <svg
            *ngIf="isStepCompleted('publish')"
            class="tab-step__check"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
          <ng-container *ngIf="!isStepCompleted('publish')">4</ng-container>
        </span>
        <span class="tab-step__label">Publish</span>
      </div>
    </div>
    <button
      type="button"
      class="close-btn"
      title="Hide Panel"
      (click)="onClose()"
    >
      <svg class="chevrons-left" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m11 17-5-5 5-5" />
        <path d="m18 17-5-5 5-5" />
      </svg>
    </button>
  </div>
  <div class="tab-content">
    <ng-container [ngSwitch]="activeTab">
      <evrideo-clipping-studio-destination-tab *ngSwitchCase="'dest'"></evrideo-clipping-studio-destination-tab>
      <evrideo-clipping-studio-metadata-tab *ngSwitchCase="'metadata'"></evrideo-clipping-studio-metadata-tab>
      <evrideo-clipping-studio-thumbnail-tab *ngSwitchCase="'thumbnail'"></evrideo-clipping-studio-thumbnail-tab>
      <evrideo-clipping-studio-publish-tab *ngSwitchCase="'publish'"></evrideo-clipping-studio-publish-tab>
    </ng-container>
  </div>
  <div class="right-sidebar__footer">
    <div class="right-sidebar__footer-error" *ngIf="footerStatusMessage">
      <p class="right-sidebar__footer-error-text">{{ footerStatusMessage }}</p>
    </div>

    <p class="right-sidebar__tiktok-declaration" *ngIf="publishState.tikTokDeclaration()">
      {{ publishState.tikTokDeclaration() }}
    </p>

    <!-- Step 1: Next only (full width) -->
    <button
      *ngIf="isFirstStep"
      type="button"
      class="right-sidebar__btn right-sidebar__btn--primary"
      [disabled]="isDestNextDisabled"
      [title]="destNextDisabledTitle"
      (click)="goNext()"
    >
      Next
      <svg
        class="right-sidebar__btn-icon"
        width="18" height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    </button>

    <!-- Step 4: Publish and Exit (full width, above nav row) -->
    <button
      *ngIf="isLastStep"
      type="button"
      class="right-sidebar__btn right-sidebar__btn--secondary"
      [disabled]="!publishState.canPublish()"
      [title]="publishDisabledTitle"
      (click)="publishExit.emit()"
    >
      Publish & Exit
    </button>

    <!-- Steps 2–3: Back + Next; Step 4: Back + Publish and Continue -->
    <div *ngIf="showNavRow" class="right-sidebar__footer-row">
      <button
        type="button"
        class="right-sidebar__btn right-sidebar__btn--secondary right-sidebar__btn--row-back"
        (click)="goBack()"
      >
        <svg
          class="right-sidebar__btn-icon"
          width="18" height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
        Back
      </button>

      <button
        *ngIf="!isLastStep && activeTab === 'thumbnail'"
        type="button"
        class="right-sidebar__btn right-sidebar__btn--primary right-sidebar__btn--row-next"
        [disabled]="isThumbNextDisabled"
        (click)="goNext()"
      >
        Next
        <svg
          class="right-sidebar__btn-icon"
          width="18" height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>

      <button
        *ngIf="!isLastStep && activeTab === 'metadata'"
        type="button"
        class="right-sidebar__btn right-sidebar__btn--primary right-sidebar__btn--row-next"
        [disabled]="isMetaNextDisabled"
        [title]="metaNextDisabledTitle"
        (click)="goNext()"
      >
        Next
        <svg
          class="right-sidebar__btn-icon"
          width="18" height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>

      <button
        *ngIf="isLastStep"
        type="button"
        class="right-sidebar__btn right-sidebar__btn--primary right-sidebar__btn--row-next"
        [disabled]="!publishState.canPublish()"
        [title]="publishDisabledTitle"
        (click)="publishContinue.emit()"
      >
        <svg class="right-sidebar__btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        Publish & Continue
      </button>
    </div>
  </div>
</div>
